import Alpine from 'alpinejs';
document.addEventListener("alpine:init", () => {

    Alpine.data('captionEditor', (current_ig_account_id, caption_id, content = "", status = "", proposed_caption_content = "", writing_mode = "for_me") => ({
        caption_id: caption_id,
        currentIgAccountId: current_ig_account_id,
        isSaved: true,
        isSaving: false,
        isEditingTitle: false,
        caption_title: '',
        content: content, 
        proposed_caption_content: proposed_caption_content,
        writingMode: writing_mode,
        maxLength: 1200,
        purpose: '',
        formula: '',
        message_length: 'short',
        tone: '',
        caption_feedback: '',
        editorMode: 'edit',
        showEditButton: false,
        status: status,
        retryInterval: null,
        show_content: 0,
        

        init() {
            this.caption_title = document.getElementById('caption_title').value;

            if( this.content != "" ) {
                this.content = this.content.replace(/\n/g, "<br>");
            }

            if( this.proposed_caption_content != "" ) {
                this.proposed_caption_content = this.proposed_caption_content.replace(/\n/g, "<br>");
                this.show_content = 1;
            }
            //prevent 'backspace' key from navigating back
            document.addEventListener('keydown', function(e) {
                if(e.key === 'Backspace' && e.target === document.body) {
                    e.preventDefault();
                }
            });

            if( this.caption_id != null ) {
                this.editorMode = 'view';

                if (this.status === 'generating' || this.status == "editing" || this.status == "retrying" ) {
                    this.startCaptionRefresh();  // Start polling for updates
                }
            }

            this.getInitialPurpose();
            this.getInitialFormula();
            this.getInitialMessageLength();
            this.getInitialTone();
        },

        changeEditorMode(mode){
            if( mode == 'edit'){
                this.editorMode = 'edit';
                //change <br> to \n
                this.content = this.content.replace(/<br>/g, "\n");
            }

            if( mode == 'view'){
                this.editorMode = 'view';
                //change \n to <br>
                this.content = this.content.replace(/\n/g, "<br>");
            }
        },

        getInitialPurpose() {
            let purpose = document.getElementById('caption_purpose').value;
            if (purpose) {
                this.purpose = purpose;
            }
        },

        getInitialFormula() {
            let formula = document.getElementById('caption_formula').value;
            if (formula) {
                this.formula = formula;
            }
        },

        getInitialMessageLength() {
            let message_length = document.getElementById('caption_message_length').value;
            if (message_length) {
                this.message_length = message_length;
            }
        },

        getInitialTone() {
            let tone = document.getElementById('caption_tone').value;
            if (tone) {
                this.tone = tone;
            }
        },
        
        saveButtonText() {
            if( caption_id == null ) {
                return 'Create'
            }else{
                if (this.isSaving) {
                    return 'Saving...'
                } else if (this.isSaved) {
                    return 'View';
                } else {
                    return 'Save changes';
                }
            }
        },

        saveCaption() {
            this.isSaving = true;
            let newCaption = true;
            if( this.caption_id != null ) {
                newCaption = false;
            }
        
            // Prepare payload for Rails
            const payload = {
                caption: {
                    title: this.caption_title,
                    content: this.content,
                    purpose: this.purpose,
                    formula: this.formula,
                    message_length: this.message_length,
                    tone: this.tone,
                    writing_mode: this.writingMode,
                }
            };

            
            // Send to Rails backend via AJAX or fetch
            fetch(this.caption_id ? `/captions/${this.caption_id}` : "/captions", {
                method: this.caption_id ? "PUT" : "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
                },
                body: JSON.stringify(payload)
            })
            .then(response => response.json())
            .then(data => {
                this.isSaving = false;
                if (!data.id) {
                    throw new Error("Save failed: " + JSON.stringify(data.error));
                }

                if (!this.caption_id) {
                    this.caption_id = data.id; // Set caption_id from Rails response
                }
                //console.log
                console.log('succes:', data);
                this.isSaved = true; // Mark as saved
                if( newCaption ) {
                    window.location.href = `/captions/${this.caption_id}/`;
                }else{
                    this.changeEditorMode('view');
                    return fetch(`/captions/${this.caption_id}.json`);
                }
            })
            .then(response => response.json())
            .catch(error => console.error("Error saving or loading flow:", error));
        },

        rewriteCaption() {
            if (!this.caption_id) {
                alert("Caption ID is missing.");
                return;
            }
            // Prepare payload for Rails
            const payload = {
                feedback: this.caption_feedback,
            };

            this.status = 'generating';

            fetch(`/captions/${this.caption_id}/retry_suggested_caption`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
                },
                body: JSON.stringify(payload)
            })
            .then(response => {
                if (!response.ok) throw new Error("Error triggering rewrite");
                this.startCaptionRefresh();  // Start polling for updates
            })
            .catch(error => {
                console.error("Rewrite Error:", error);
                this.status = 'ready';
            });
        },

        rejectSuggestion() {
            if (!this.caption_id) {
                alert("Caption ID is missing.");
                return;
            }
            this.status = 'editing';

            fetch(`/captions/${this.caption_id}/reject_suggested_caption`, {
                method: "POST",
                headers: {
                    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
                },
            })
            .then(response => {
                if (!response.ok) throw new Error("Error triggering rewrite");
                this.startCaptionRefresh();  // Start polling for updates
            })
            .catch(error => {
                console.error("Rewrite Error:", error);
                this.status = 'ready';
            });
        },

        acceptSuggestion() {
            if (!this.caption_id) {
                alert("Caption ID is missing.");
                return;
            }
            this.status = 'editing';

            fetch(`/captions/${this.caption_id}/accept_suggested_caption`, {
                method: "POST",
                headers: {
                    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
                },
            })
            .then(response => {
                if (!response.ok) throw new Error("Error triggering rewrite");
                this.startCaptionRefresh();  // Start polling for updates
            })
            .catch(error => {
                console.error("Rewrite Error:", error);
                this.status = 'ready';
            });
        },

        startCaptionRefresh() {
            this.retryInterval = setInterval(() => {
                fetch(`/captions/${this.caption_id}/refresh`, {
                    method: "POST",
                    headers: {
                        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
                    }
                })
                .then(response => response.json())
                .then(data => {
                    if (data.status === "ready") {
                        clearInterval(this.retryInterval);
                        this.refreshCaptionContent();
                    }
                })
                .catch(error => {
                    console.error("Error checking status:", error);
                });
            }, 2000);
        },

        refreshCaptionContent() {
            fetch(`/captions/${this.caption_id}.json`)
            .then(response => response.json())
            .then(data => {
                this.content = data.caption.content.replace(/\n/g, "<br>");
                this.$dispatch('content-updated', { content: this.content }); 
                if (data.proposed_caption_content != "") {
                    this.proposed_caption_content = data.proposed_caption_content.replace(/\n/g, "<br>");
                    this.show_content = 1;
                } else {
                    this.proposed_caption_content = "";
                    this.show_content = 0;
                }
                this.status = 'ready';
            })
            .catch(error => console.error("Error fetching updated caption:", error));
        },

        contentLabel() {
            return this.writingMode === 'for_me' ? 'Outline your post caption' : 'Write your post caption';
        }
    }));

    Alpine.data('captionSlayerForm', (config) => ({
        size: config.size,
        five_dots: config.five_dots,
        copy_both: config.copy_both,
        hashtag_newlines: config.hashtag_newlines,
        capitalization: config.capitalization,
        include_dead: config.include_dead,
        optimization_mode: config.optimization_mode,
        ig_account: config.ig_account,
        caption: config.caption,
        collections: config.collections,
        onboarding_counter: config.onboarding_counter,
        loading: false,
        parentScope: null,

        updateCaption(newCaption) {
            this.caption = newCaption;
        },    
    
        submitForm() {
            this.loading = true;
            
            fetch("/regenerate_slayer", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
                },
                body: JSON.stringify({
                    size: this.size,
                    five_dots: this.five_dots,
                    copy_both: this.copy_both,
                    hashtag_newlines: this.hashtag_newlines,
                    capitalization: this.capitalization,
                    include_dead: this.include_dead,
                    optimization_mode: this.optimization_mode,
                    ig_account: this.ig_account,
                    caption: this.caption.replace(/<br>/g, "\n"),
                    collections: this.collections,
                    onboarding_counter: config.onboarding_counter
                })
            })
            .then(response => response.json())
            .then(data => {
                this.loading = false;
                window.location.href = '/?onboarding='+ this.onboarding_counter;
            })
            .catch(error => {
                console.error("Error:", error);
                this.loading = false;
            });
        }
    }));

    Alpine.data('captionsIndex', () => ({
        show: 0,

        init() {
            if ( document.querySelector('#save-samples-button') != null ) {
                document.querySelector('#save-samples-button').addEventListener('click', this.submitForm);
            }
        },
        
        submitForm() {
            document.getElementById('set-sample-captions-form').submit();
        }
    }));
    
});